<app-header [navbarBrandRouterLink]="['/dashboard']" [fixed]="true"
    [navbarBrandFull]="{src: 'assets/img/brand/logo_new.png', width: 200, height: 100, alt: 'INVIT Logo'}"
    [navbarBrandMinimized]="{src: 'assets/img/brand/icon.png',width: 50, height: 20, alt: 'INVIT Icon'}"
    [sidebarToggler]="'lg'" class="animated fadeIn appHeader" [asideMenuToggler]="false">
    <ul class="nav navbar-nav ml-auto">
        <li class="nav-item d-md-down-none">
            <h6 class="welComeUserName fade-in" style="font-size: 13px;">&nbsp;Welcome!!!
                <!-- <i class="fa fa-handshake-o"></i> -->
                {{name}}
            </h6>
        </li>
        <li class="nav-item dropdown" placement="bottom right">
            <a class="nav-link cursor" appAsideMenuToggler>
                <i class="icon-bell bellIconCss" title="Notification"></i>
                <span class="badge badge-pill badge-info unReadCount"
                    [hidden]="notificationCount.unReadTotal==0 ||notificationCount.unReadTotal==null"
                    title="Un-Read Notification">{{notificationCount.unReadTotal}} </span>
            </a>
        </li>
        <li class="nav navbar-nav ml-auto">
        <li class="nav-item dropdown" dropdown placement="bottom right">
            <a class="nav-link" href="#" role="button" aria-haspopup="true" aria-expanded="false" dropdownToggle
                (click)="false">
                <!-- <img src="assets/img/avatars/7.jpg" class="img-avatar" alt="lissomsoft.com" /> -->
                <span class="logIn">
                    <p class="">{{profileName}}</p>
                </span>
            </a>
            <div class="dropdown-menu dropdown-menu-right md-12
            " *dropdownMenu aria-labelledby="simple-dropdown">
                <div class="dropdown-header text-center bg-light profileHeader "><strong
                        style="font-size: 17px; color: black;"><i class="fa fa-user-circle-o"
                            aria-hidden="true"></i>&nbsp;Profile</strong></div>
                <div class="dropdown-header  profileDetails bg-dark">
                    <div class="input-group mb-3">
                        <span class="info">User
                            Name</span>
                        <span class="details" placement="bottom" triggers="mouseenter:mouseleave"
                            ngbPopover="{{ name }}"> {{
                            name
                            | slice: 0:15}}</span>
                    </div>
                    <div class="input-group mb-3">
                        <span class="info">Department
                        </span>
                        <span class="details" placement="bottom" triggers="mouseenter:mouseleave"
                            ngbPopover="{{ departmentName }}"> {{
                            departmentName
                            | slice: 0:15}}</span>
                    </div>
                    <div class="input-group mb-3">
                        <span class="info">
                            Role
                        </span>
                        <span class="details" placement="bottom" triggers="mouseenter:mouseleave"
                            ngbPopover="{{ roleName }}"> {{
                            roleName
                            | slice: 0:15}}</span>
                    </div>
                </div>
                <a class="dropdown-header text-center bg-light profileHeader" (click)="logOut()"
                    style="font-size: 20px; color: black;"><i class="fa fa-sign-out" aria-hidden="true"
                        style="font-size: 20px;"></i> <strong>Log-Out</strong> </a>
            </div>
        </li>
    </ul>
</app-header>
<div class="app-body">
    <app-sidebar #appSidebar [fixed]="true" [display]="'lg'" [minimized]="sidebarMinimized"
        (minimizedChange)="toggleMinimize($event)">
        <app-sidebar-nav [navItems]="navItems" [perfectScrollbar] [disabled]="appSidebar.minimized"></app-sidebar-nav>
        <app-sidebar-minimizer></app-sidebar-minimizer>
    </app-sidebar>
    <!-- Main content -->
    <main class="main">
        <cui-breadcrumb>
            <li class="breadcrumb-menu d-md-down-none">
                <a (click)="downloadManual()">
                    <i class="fa fa-download text-dark" aria-hidden="true">&nbsp; <strong
                            style="color: black; font-family:'Courier New', Courier, monospace;"> User Guide</strong>
                    </i>
                </a>
            </li>
        </cui-breadcrumb>
        <div class="container-fluid">
            <router-outlet></router-outlet>
        </div>
    </main>
    <app-aside [fixed]="true" [display]="false" class="ss" [ngClass]="'test'">
        <tabset>
            <tab>
                <ng-template tabHeading><i class="fa fa-bell"> <strong> Notification</strong> </i> </ng-template>
                <div class="list-group list-group-accent">
                    <div class="list-group-item list-group-item-accent-warning list-group-item-divider"
                        *ngFor="let info of notificationList.slice().reverse() let i=index;"
                        [ngSwitch]="info.readStatus">
                        <span appAsideMenuToggler class="notificationMessgae "><a
                                (click)="goToPage(info.notificationId,info.source,info.refId,info.refNo)">{{info.message}}&nbsp;</a></span>
                        <small class="text text-dark font-weight-bold mr-3">
                            <i class="fa fa-clock-o" aria-hidden="true"></i> &nbsp;{{info.timeAgo}}</small>
                        <i class="fa fa-circle text-primary" *ngIf="info.readStatus==0" title="un-read">
                        </i>
                        <!-- <div class="alert alert-info">
                                <strong>No Notification
                                    Found!!!</strong>
                            </div> -->
                    </div>
                </div>
            </tab>
        </tabset>
    </app-aside>
</div>
<app-footer class="appFooter">
    <span class="ml-auto text-light">Powered by <a href="http://www.lissomsoft.com/"
            target="_blank">LissomSoft</a></span>
</app-footer>
